import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
    selector: 'unified-ui-datetime-custom-filter',
    standalone: true,
    imports: [FormsModule, DatePickerModule],
    templateUrl: './datetime-custom-filter.component.html',
    styleUrl: './datetime-custom-filter.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateTimeCustomFilterComponent {
    public readonly label = input.required<string>();
    public readonly date = model<{ startDate?: string; endDate?: string }>({});


    public readonly minDate = computed<Date | undefined>(() => {
        const date = this.date();
        return date.startDate ? new Date(date.startDate) : undefined;
    });

    public readonly maxDate = computed<Date | undefined>(() => {
        const date = this.date();
        return date.endDate ? new Date(date.endDate) : undefined;
    });

    public updateStartDate(value: string): void {
        const currentDate = this.date();
        this.date.set({
            ...currentDate,
            startDate: value
        });
    }

    public updateEndDate(value: string): void {
        const currentDate = this.date();
        this.date.set({
            ...currentDate,
            endDate: value
        });
    }
}
